module.exports={
    logout  : "退出帳號",
    my      :'我的',
    scqx    :'删除許可權',
    qxgl    :'許可權管理',
    qdzxzhm :'確定註銷帳號嗎？',
    qtxkh   :'請填寫卡號',
    qd      :'確定',
    qx      :'取消',
    gb      :'關閉',
    kh      :'卡號',
    kmewm   :'開門二維碼',
    dl      :'登录',
    name    :'用戶名',
    qtxname :'請填寫用戶名',
    pwas    :'密碼',
    qtxpwas :'請填寫密碼',
    tj      :'提交',
    zczh    :'註冊帳號',
    zc      :'注册',
    sjhm    :'手機號碼',
    qtxsjhm :'請填寫手機號碼',
    yzm     :'簡訊驗證碼',
    qtxyzm  :'請填寫驗證碼',
    yyzhqqdl:'已有帳號，前去登入',
    hqyzm   :'獲取簡訊驗證碼',
    zccg    :'注册成功',
    zcsb    :'注册失敗',
    fscg    :'發送成功',
    fssb    :'發送失敗',
    yhycz   :'用戶已存在'
}